import { render } from "./TheMyCollectionMain.vue?vue&type=template&id=1d35d164&scoped=true&ts=true"
import script from "./TheMyCollectionMain.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionMain.vue?vue&type=script&lang=ts"

import "./TheMyCollectionMain.vue?vue&type=style&index=0&id=1d35d164&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d35d164"]])

export default __exports__